import React from 'react';
import { useInputCommon } from '../../hooks';
import styles from './TextArea.module.scss';

type TextAreaProps = {
    label?: string;
    error?: string;
    helperText?: string;
    resize?: 'none' | 'vertical' | 'horizontal' | 'both';
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
    ({ label, error, helperText, className, resize = 'vertical', ...textareaProps }, ref) => {
        const textareaClassName = `${styles.textArea} ${error ? styles.error : ''} ${className || ''}`.trim();
        const resizeClass = styles[`resize-${resize}`] || '';
        const finalClassName = `${textareaClassName} ${resizeClass}`.trim();

        const { labelElement, errorTextElement, helperTextElement, containerClasses } = useInputCommon({
            id: textareaProps.id,
            label,
            error: !!error,
            errorText: error,
            helperText,
            required: !!textareaProps.required,
            disabled: !!textareaProps.disabled,
            className,
            inputType: 'textarea',
        });

        return (
            <div className={containerClasses}>
                {labelElement}
                <textarea className={finalClassName} ref={ref} {...textareaProps} />
                {errorTextElement}
                {helperTextElement}
            </div>
        );
    }
);

TextArea.displayName = 'TextArea';
